import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { RepresentanteModule } from '../pessoa/representante';
import { CidadeModule } from '../cidade';
import { RegiaoSituacaoModule } from './situacao';
import { RegiaoIntegracaoErpImportModule } from './integracoes/erp/import';

import { RegiaoRoutingModule } from './regiao-routing.module';
import { RegiaoComponent } from './regiao.component';
import { RegiaoFormComponent} from './form';
import { RegiaoCidadeComponent } from './cidade';
import { RegiaoCidadeSubRegiaoComponent } from './cidade/sub-regiao';
import { RegiaoCidadePopulaModalComponent } from './cidade/popula-modal';
import { RegiaoFilterCollapseComponent } from './filter';
import { RegiaoRepresentanteComponent, RegiaoRepresentantePopulaModalComponent } from './representante';

@NgModule({
    imports: [
        SharedModule,
        RegiaoRoutingModule,
        RepresentanteModule,
        CidadeModule,
        RegiaoSituacaoModule,
        RegiaoIntegracaoErpImportModule
    ],
    declarations: [
        RegiaoComponent,
        RegiaoFormComponent,
        RegiaoCidadeComponent,
        RegiaoCidadeSubRegiaoComponent,
        RegiaoCidadePopulaModalComponent,
        RegiaoFilterCollapseComponent,
        RegiaoRepresentanteComponent,
        RegiaoRepresentantePopulaModalComponent
    ]
})
export class RegiaoModule { }
